// A KEZDŐLAP CSEMPE-TERÜLETE (nézet-mód): EGY folytonos rács (`DASHBOARD_GRID_CLASS`), a csempék a felhasználó
// sorrendjében. A szélességet a `layout/spans.ts` adja (kicsi/közepes/széles); a `row dense` a lyukakat tölti, a DOM-sorrend
// (a11y, billentyű) a felhasználó listája marad. A sor-magasság a legmagasabb csempéé: a cella `grid`, így a benne álló
// kártya megnyúlik (`align-items: stretch`); a hosszú tartalmú kártyák saját plafonnal görgetnek (`PanelCard capped`).
import { type ResolvedTile } from '@atlas/shared';

import {
  DASHBOARD_GRID_CLASS,
  tileSpanClass,
  tileSpanKind,
} from '@/features/dashboard/layout/spans';
import { TileView, type TileContext } from '@/features/dashboard/tiles/registry';
import { cn } from '@/lib/utils';

export function DashboardTiles({
  tiles,
  ctx,
}: {
  tiles: ResolvedTile[];
  ctx: TileContext;
}): JSX.Element {
  return (
    <div className={DASHBOARD_GRID_CLASS} data-testid="dashboard-tiles">
      {tiles.map((tile) => {
        const kind = tileSpanKind(tile);
        return (
          // `min-w-0`: a rács-elem ne szélesedjen a tartalma miatt (nincs vízszintes túlfolyás);
          // `empty:hidden`: a null-t renderelő csempe (jog/üres) nem foglal cellát
          <div
            key={tile.def.id}
            data-tile={tile.def.id}
            data-span={kind}
            className={cn('grid min-w-0 empty:hidden', tileSpanClass(kind))}
          >
            <TileView tile={tile} ctx={ctx} />
          </div>
        );
      })}
    </div>
  );
}
